import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage } from "../message";
import EventBus from "../../../utils/EventBus";
import ShowcaseAPI from "../../../Api/showcaseapi";



export const fetchTags = createAsyncThunk("tag/fetchTags", async (params, thunkAPI) => {
    try {
        const response = await ShowcaseAPI.getTag(params);
        return response.data;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            EventBus.dispatch("logout");
        }
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message);
    }
});



export const addTag = createAsyncThunk("tag/addTag", async (formData, thunkAPI) => {
    try {
        const response = await ShowcaseAPI.addTag(formData);
        return response.data;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            EventBus.dispatch("logout");
        }
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message);
    }
});



export const updateTag = createAsyncThunk("tag/updateTag", async ({ id, formData }, thunkAPI) => {
    try {
        const response = await ShowcaseAPI.updateTag(id, formData);
        return response.data;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            EventBus.dispatch("logout");
        }
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message);
    }
});



export const deleteTag = createAsyncThunk("tag/deleteTag", async (id, thunkAPI) => {
    try {
        const response = await ShowcaseAPI.deleteTag(id);
        return id;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            EventBus.dispatch("logout");
        }
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message);
    }
});



const tagSlice = createSlice({
    name: "tag",
    initialState: {
        tags: [],
        error: null, 
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchTags.fulfilled, (state, action) => {
                state.tags = action.payload.data;
            })
            .addCase(addTag.fulfilled, (state, action) => {
                state.tags.push(action.payload.data);
            })
            .addCase(updateTag.fulfilled, (state, action) => {
                const updatedTag = action.payload.data;
                state.tags = state.tags.map((tag) => (tag.id === updatedTag.id ? updatedTag : tag));
            })
            .addCase(deleteTag.fulfilled, (state, action) => {
                state.tags = state.tags.filter((tag) => tag.id !== action.payload);
            })
            .addCase(fetchTags.rejected, (state, action) => {
                state.error = action.payload; 
            })
            .addCase(addTag.rejected, (state, action) => {
                state.error = action.payload;
            })
            .addCase(updateTag.rejected, (state, action) => {
                state.error = action.payload;
            })
            .addCase(deleteTag.rejected, (state, action) => {
                state.error = action.payload;
            });
    },
});

const { reducer } = tagSlice;
export default reducer;
